import { render } from "./VoucherTplDialog.vue?vue&type=template&id=2368897a&scoped=true"
import script from "./VoucherTplDialog.vue?vue&type=script&lang=js"
export * from "./VoucherTplDialog.vue?vue&type=script&lang=js"

import "./VoucherTplDialog.vue?vue&type=style&index=0&id=2368897a&lang=less&scoped=true"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2368897a"]])

export default __exports__